
<template>
  <div>
    <v-card>
      <v-card-title class="pa-3 pa-md-4">
        Conferência Realizadas<br/>
        <v-spacer />
        <v-btn :loading="carregando" class="primary" elevation="0"> Iniciar Conferência </v-btn>
      </v-card-title>
      <v-progress-linear indeterminate color="primary" :active="carregando" />
      <v-divider />
      <v-card-text class="pa-0">
        <v-data-table
            mobile-breakpoint="0"
            hide-default-footer :headers="[
            { text: 'ID', value: 'idlista', align: 'start', sortable: false  },
            { text: 'Notas', value: 'lista', align: 'start', sortable: false  },
            { text: 'Qtde Skus', value: 'qtditens', align: 'center', sortable: false  },
            { text: 'Conferente', class: 'd-md-table-cell d-none', value: 'usucadastro', align: 'center', sortable: false  },
            { text: 'Data de Conferência', class: 'd-md-table-cell d-none', value: 'dtcadastro', align: 'center', sortable: false  },
            { text: 'Ações', value: 'acoes', align: 'center', sortable: false  },
          ]"
          :items="lista.lista"
          :items-per-page="pgLimitInt"
        >
        </v-data-table>
        <v-divider />
        <Paginacao
            class="py-2"
            @atualizar="listaListar"
            :total="lista.total"
            :pgLimitInt="pgLimitInt"
            :carregando="carregando"
            :pg="pgSelecionada"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Paginacao from "@/Components/Widgets/Paginacao.vue";
import {mapState} from "vuex";

export default {
  components: {
    Paginacao,
  },
  data() {
    return {
      carregando:false,
      lista: { lista: [], total: 0 },
      pgLimitInt:20,
    };
  },
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),
  },
  methods: {
    resetaCache(){
      this.idlista=null;
      this.nomeLista='';
      this.codigoDeBarras='';
      this.dialogConfirmaContinuacao=false;
      this.dialog = true;
      localStorage.removeItem("etiquetas");
    },

    salvaCache(){
      localStorage.setItem("etiquetas", JSON.stringify(this.listaProdutosSelecionados));
    },

    listaListar(pg){
      this.pgSelecionada = pg;
      this.carregando = true;
      try {
        return axios
          .post(`${this.backendUrl}etiqueta/lista/listar`, {
            limit: this.pgLimitInt,
            offset: this.pgLimitInt * (pg),
          })
          .then(() => {
            // this.lista.lista = res.data.lista == null ? [] : res.data.lista;
            // this.lista.total = res.data.total;
            this.lista.lista = [];
            this.lista.total = 0;
          })
          .catch(() =>{
            window.location.reload();
          })
          .finally(() =>{
            this.carregando = false;
          });
      } catch (error) {
        console.error("Erro ao consultar a API:", error);
      }
    },

    buscaProduto(pg, tamanho){
      this.pgSelecionada2 = pg;
      this.carregando = true;
      try {
        return axios
            .post(`${this.backendUrl}etiqueta/busca/produtos`, {
              busca: this.codigoDeBarras,
              idempresa: 1,
              limit: this.pgLimitInt2,
              offset: this.pgLimitInt2 * (pg-1),
              flagestoque: !this.busca.flagestoque
            })
            .then((res) => {
              if (res.data.total > 0){
                this.produtos.lista = res.data.lista == null ? [] : res.data.lista.map((v) => {
                  const compositeKey = `${v.idsubproduto}-${(v.preco - v.precopromocao).toFixed(2)}`;
                  const selectedProduto = this.listaProdutosSelecionados.lista.find(u => u.compositeKey === compositeKey);
                  const quantidade = selectedProduto ? selectedProduto.quantidade : 1;
                  return {
                    ...v,
                    compositeKey: compositeKey,
                    quantidade: quantidade,
                  };
                });
                this.produtos.total = res.data.total;
                if(tamanho==='P'){
                  this.dialogDetalhes=true;
                } else {
                  this.dialogDetalhes=false;
                }
              } else {
                this.snackbar2.text = 'Produto não encontrado, por favor verifique o produto informado e o filtro de estoque'
                this.snackbar2.color = 'error';
                this.snackbar2.status = true;
              }
              this.carregando = false;
            })
            .catch(() =>{
              this.carregando = false;
              window.location.reload();
            });
      } catch (error) {
        console.error("Erro ao consultar a API:", error);
      }
    },

    async init(){
      await this.listaListar(0);
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped>
::v-deep .v-data-table__mobile-table-row td {
  min-height: 30px !important; /* Ajuste a altura conforme necessário */
  font-size: 0.8em !important;
}

::v-deep .v-data-table__mobile-table-row td {
  min-height: 30px !important; /* Ajuste a altura conforme necessário */
  font-size: 0.8em !important;
}

::v-deep .custom-text-field .v-input__prepend-inner {
  margin-right: 6px !important; /* Ajuste o valor para o espaçamento desejado */
}

::v-deep .custom-text-field:is(.v-input--is-label-active, .v-input--is-focused) .v-label {
  margin-left: 31px !important; /* Adiciona espaço à label */
}

::v-deep .custom-text-field.v-text-field--outlined fieldset {
  padding-left: 45px !important; /* Ajuste conforme necessário */
}

.scanner {
  position: relative;
  height: 100%;
  width: 100%;
  border: 12px #e3e3e3 solid !important;
  border-radius: 6px;
}

.corner-rectangle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 220px;
  height: 80px;
  transform: translate(-50%, -50%);
  z-index: 1;
}

/* Estilo das vértices */
.corner {
  position: absolute;
  width: 20px;
  height: 20px;
  border: 3px solid white;
}

/* Vértices superiores */
.top-left {
  top: -3px;
  left: -3px;
  border-right: none;
  border-bottom: none;
}

.top-right {
  top: -3px;
  right: -3px;
  border-left: none;
  border-bottom: none;
}

/* Vértices inferiores */
.bottom-left {
  bottom: -3px;
  left: -3px;
  border-right: none;
  border-top: none;
}

.bottom-right {
  bottom: -3px;
  right: -3px;
  border-left: none;
  border-top: none;
}

.laser-line {
  position: absolute;
  top: 50%; /* Centraliza verticalmente */
  left: 0;
  width: 100%;
  height: 1px;
  background-color: red;
  box-shadow: 0px 0px 8px red; /* Efeito de brilho na linha */
}

/* Estilo do botão Adicionar */
.add-button {
  position: absolute;
  bottom: 5px;
  left: 40px;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 10;
}

.error {
  color: red;
  margin-top: 20px;
  font-weight: bold;
}

.teclado-row {
  display: flex;
  justify-content: space-between;
}

.teclado-row button {
  flex: 1;
  margin: 5px;
  padding: 20px; /* Aumenta o tamanho das teclas */
  font-size: 1.5rem; /* Aumenta o tamanho do texto */
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.teclado-row button:hover {
  background-color: #e0e0e0;
}

.teclado-row v-icon {
  font-size: 1.5rem; /* Tamanho dos ícones */
}

::v-deep .dialog-detalhes {
  margin: 5px 14px 50px 14px !important;
  box-shadow: none !important;
  scrollbar-width: thin; /* Largura da barra de rolagem */
  scrollbar-color: #f1f1f1 #023449; /* Cor da barra de rolagem e da trilha */
}

/* Estilizando a barra de rolagem para navegadores WebKit */
::v-deep .dialog-detalhes::-webkit-scrollbar {
  width: 8px; /* Largura da barra de rolagem */
}

::v-deep .dialog-detalhes::-webkit-scrollbar-track {
  background: #f1f1f1; /* Cor de fundo da trilha */
}

::v-deep .dialog-detalhes::-webkit-scrollbar-thumb {
  background-color: #f1f1f1; /* Cor da barra de rolagem */
  border-radius: 10px; /* Bordas arredondadas */
  border: 2px solid #023449; /* Espaço ao redor da barra de rolagem */
}
</style>
